import type { FC } from 'react';
import { Trans } from 'react-i18next';

import {
    Anchor,
    Body1,
    Heading4,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { PathwayTerms } from '../../configuration/shared';
import type { FillPathway } from '../../contexts/fill';
import type { DrugKeyType } from '../../util/config/constants';
import { getAbsoluteRoute } from '../../util/get-absolute-route';

export type ShortProgramTermsProps = {
    drugKey: DrugKeyType | null;
    pathway: FillPathway;
    terms: PathwayTerms | null;
};

export const ShortProgramTerms: FC<ShortProgramTermsProps> = ({
    drugKey,
    pathway,
    terms,
}) => {
    if (!drugKey || !terms?.savingsCard) {
        return null;
    }

    return (
        <Stack gap="xxs">
            <Heading4>
                <Trans
                    ns="dynamic"
                    defaults={terms.savingsCard.shortDesc.heading}
                />
            </Heading4>
            <Body1>
                <Trans
                    ns="dynamic"
                    defaults={terms!.savingsCard.shortDesc.body}
                    components={{
                        1: (
                            <Anchor
                                href={getAbsoluteRoute(
                                    'programs.drugKey.terms.pathway',
                                    { drugKey, pathway }
                                )}
                            />
                        ),
                    }}
                />
            </Body1>
        </Stack>
    );
};
